// One way to show dates on every screen: 21-Nov-2026 (and 21-Nov-2026 13:02 with the time, India time).
// Saved values never change; this only decides what is shown.
const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

function istParts(d) {
  const p = {};
  new Intl.DateTimeFormat("en-GB", { timeZone: "Asia/Kolkata", day: "2-digit", month: "numeric", year: "numeric", hour: "2-digit", minute: "2-digit", hourCycle: "h23" })
    .formatToParts(d).forEach((x) => { p[x.type] = x.value; });
  return p;
}

// Firestore timestamp, Date, milliseconds, ISO text or "2026-11-21" -> Date (or null)
function toDateObj(v) {
  if (v === null || v === undefined || v === "") return null;
  if (typeof v.toDate === "function") return v.toDate();
  if (v instanceof Date) return v;
  if (typeof v === "object" && typeof v.seconds === "number") return new Date(v.seconds * 1000);
  const d = new Date(v);
  return isNaN(d.getTime()) ? null : d;
}

// 21-Nov-2026. Empty gives "—". Text that is not a date is shown as it is.
export function fmtD(v) {
  if (v === null || v === undefined || v === "") return "—";
  if (typeof v === "string") {
    const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(v.trim());
    if (m) return m[3] + "-" + MONTHS[Number(m[2]) - 1] + "-" + m[1];
  }
  const d = toDateObj(v);
  if (!d) return typeof v === "string" ? v : "—";
  const p = istParts(d);
  return p.day + "-" + MONTHS[Number(p.month) - 1] + "-" + p.year;
}

// 21-Nov-2026 13:02 (India time)
export function fmtDT(v) {
  if (v === null || v === undefined || v === "") return "—";
  const d = toDateObj(v);
  if (!d) return typeof v === "string" ? v : "—";
  const p = istParts(d);
  return p.day + "-" + MONTHS[Number(p.month) - 1] + "-" + p.year + " " + p.hour + ":" + p.minute;
}
